exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tooltip-inner:has(.priority-custom-tooltip) {\n  max-width: 250px !important;\n  width: 250px !important;\n  background-color: white !important;\n  color: black;\n  border: 1px solid #bbbbbb;\n}\n.custom-tooltip:has(.arrow::before) {\n  bottom: 0 !important;\n  border-width: 0 0.4rem 0.4rem !important;\n  border-bottom-color: #8b9121 !important;\n  background-color: #8b9121 !important;\n}\n.gap-4 {\n  gap: 4px;\n}\n", ""]);

// exports
